//extracted by mini-css-extract-plugin
export default {"itemImage":"styles_itemImage__RkGg3","resourceItem":"styles_resourceItem__YU+gY"};;